var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<input type=\"text\" ng-class=\"{ hidden: $ctrl.isHidden}\" ng-click=\"$ctrl.selectInputText()\" value=\"{{$ctrl.text}}\" class=\"copy-input\"><button ng-click=\"$ctrl.copy()\" ng-class=\"{ success: $ctrl.isSuccess }\" class=\"button secondary copy-button\">{{$ctrl.buttonText}}</button>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-clipboard-copy.jade
 ** module id = 3459
 ** module chunks = 3
 **/